import { AppProps } from "@/AppProps.ts";
import ReactPortal from "@/components/Modal/ReactPortal.tsx";
import { useCheckNewVersion } from "@/helpers/hooks/useCheckNewVersion.ts";
import { ShadowRootContext } from "@/helpers/ShadowRootContext.ts";
import { useRootAttributes } from "@/helpers/useRootAttributes.ts";
import { BookingEngine } from "@/pages/BookingEngine/BookingEngine.tsx";
import { client } from "@/stores/ApolloClient/ApolloClient.ts";
import { ApolloProvider } from "@apollo/client";
import i18n from "i18next";
import { useMemo } from "react";
import TagManager from "react-gtm-module";
import { Toaster } from "react-hot-toast";
import { I18nextProvider } from "react-i18next";
import "./i18n";

const bookingEngineDiv = document.getElementById("bookingEngine");
const gtmId = bookingEngineDiv?.getAttribute("data-gtm_id") || import.meta.env.VITE_GTM_ID;
if (gtmId) {
  const tagManagerArgs = { gtmId: gtmId };
  TagManager.initialize(tagManagerArgs);
}

export const App = (props: AppProps) => {
  useRootAttributes(props.rootDiv);
  useCheckNewVersion();

  const shadowCtx = useMemo(
    () => ({
      shadowRoot: props.shadowRoot,
      containerEl: props.shadowRoot.getElementById("bookingEngineRoot") as HTMLDivElement,
    }),
    [props.shadowRoot],
  );

  return (
    <ShadowRootContext.Provider value={shadowCtx}>
      <I18nextProvider i18n={i18n}>
        <ApolloProvider client={client}>
          <ReactPortal wrapperId="toast-container">
            <Toaster />
          </ReactPortal>
          <div className="bookingEngine">
            <BookingEngine />
          </div>
        </ApolloProvider>
      </I18nextProvider>
    </ShadowRootContext.Provider>
  );
};

export default App;
